export default function QuestionTextContainer({ text, style, children = null, animated = false }) {
    return (
        <div className={`w-full flex flex-col items-center gap-3${animated ? ' pulse-once' : ''}`}>
            <div className="TextboxContainer" style={style}>
                <div className="Textbox question-text overflow-y-auto styled-scrollbar">
                    <p>{text}</p>
                    {children}
                </div>
            </div>
        </div>
    );
}